import { render, staticRenderFns } from "./Reviewslist.vue?vue&type=template&id=199341ef&scoped=true"
import script from "./Reviewslist.vue?vue&type=script&lang=js"
export * from "./Reviewslist.vue?vue&type=script&lang=js"
import style0 from "./Reviewslist.vue?vue&type=style&index=0&id=199341ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199341ef",
  null
  
)

export default component.exports